import { Affix, Drawer, Grid, Layout } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import AdBlockAlert from '../../components/AdBlockAlert';
import CurrencyProvider from '../../components/CurrencyProvider';
import FeatureProvider from '../../components/FeatureProvider';
import NotificationModal from '../../components/NotificationModal';
import PublisherProvider from '../../components/PublisherProvider';
import SettingsProvider from '../../components/SettingsProvider';
import TimezoneProvider from '../../components/TimezoneProvider';
import UserProvider from '../../components/UserProvider';

import Footer from './Footer';
import Header from './Header';
import Menu from './Menu';
import Routes from './Routes';
import styles from './styles.module.less';
import withAuthentication from './withAuthentication';

const Home: FC = () => {
  const screens = Grid.useBreakpoint();
  const { pathname } = useLocation();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      setOpen(false);
    }
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const [collapsed, setCollapsed] = useState(window.innerWidth <= 1280);

  useEffect(() => {
    if (open && screens.md) {
      setOpen(false);
    }
  }, [open, screens.md]);

  const onDrawerToggle = () => setOpen(!open);

  const onSiderToggle = () => setCollapsed(!collapsed);

  return (
    <TimezoneProvider>
      <CurrencyProvider>
        <FeatureProvider>
          <UserProvider>
            <SettingsProvider>
              <PublisherProvider>
                <div className={styles.root} data-test-route="home">
                  <Layout className={styles.layout}>
                    <Layout.Sider
                      className={styles.sider}
                      collapsed={collapsed}
                      collapsedWidth={64}
                      width={200}
                    >
                      <Affix>
                        <Menu collapsed={collapsed} onToggle={onSiderToggle} />
                      </Affix>
                    </Layout.Sider>

                    <Layout.Content className={styles.content}>
                      <AdBlockAlert />
                      <Header
                        collapsed={collapsed}
                        onToggle={onDrawerToggle}
                        open={open}
                      />
                      <Routes />
                      <NotificationModal />
                      <Footer />
                    </Layout.Content>
                  </Layout>

                  <Drawer
                    className={styles.drawer}
                    closable={false}
                    onClose={onDrawerToggle}
                    open={open}
                    placement="left"
                    width={200}
                  >
                    <Menu collapsed={!open} onToggle={onDrawerToggle} />
                  </Drawer>
                </div>
              </PublisherProvider>
            </SettingsProvider>
          </UserProvider>
        </FeatureProvider>
      </CurrencyProvider>
    </TimezoneProvider>
  );
};

Home.displayName = 'Home';

export default withAuthentication(Home);
